export type ModalType = Modals | null;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ModalProps = any;
export type ModalTypeState = { ['modalType']: ModalType | null };
export type ModalPropsState = {
  ['modalProps']:
    | {
        ['title']?: string;
        ['message']?: string;
        ['imageClass']?: ImageFailure | ImageSuccess;
        ['buttonFirst']?: {
          ['text']: string;
          ['url']?: string;
          ['onClick']?: () => void;
        };
        ['buttonSecond']?: {
          ['text']: string;
          ['url']?: string;
          ['onClick']?: () => void;
        };
        [key: string]: ModalProps;
      }
    | {};
};

export enum ModalImages {
  Wait = 'dialog-subscription__img_wait',
  Cry = 'dialog-subscription__img_cry',
  Gift = 'dialog-subscription__img_gift',
}

export type ImageFailure = ModalImages.Wait | ModalImages.Cry;
export type ImageSuccess = ModalImages.Gift;
export type ModalsState = ModalTypeState & ModalPropsState;
export type ShowModalPayload = ModalTypeState & ModalPropsState;

export enum Modals {
  Loading = 'LOADING',
  SubscriptionApi = 'SUBSCRIPTION_API',
  SubscriptionOptions = 'SUBSCRIPTION_OPTIONS',
  FormSendGift = 'FORM_SEND_GIFT',
}
